import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {map} from 'rxjs/operators';
import {Breakpoints, BreakpointObserver} from '@angular/cdk/layout';

@Component({
  selector: 'cc-dash',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss']

})
export class DashboardComponent {

  /** Based on the screen size, switch from standard to one column per row */
  cardLayout :  any;


  ngOnInit(): void {
      this.generateCardLayout();
  }

  generateCardLayout()
  {
    this.cardLayout = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
      map(({ matches }) => {
        if (matches) {
          return {
            columns: 2,
            miniCard: { cols: 1, rows: 1 },
            chart: { cols: 2, rows: 2 },
            table: { cols: 1, rows: 4 },
          };
        }

        return {
          columns: 4,
          miniCard: { cols: 1, rows: 1 },
          chart: { cols: 2, rows: 2 },
          table: { cols: 4, rows: 4 },
        };
      })
    );

  }

  constructor(private breakpointObserver: BreakpointObserver) {
  }


}
